import { z } from 'zod';

export const StripeSchema = z.object({
  setDefault: z.boolean(),
});
